export function removeSpecialCharsAndReplaceWhiteSpaceWithDash(filename: string): string {
  const invalidChars = new RegExp('[^a-zA-Z\\d\\- ]', 'g');
  const multipleDashes = new RegExp('-+', 'g');

  let formattedFilename = filename.replace(invalidChars, '').replace(/ /g, '-');
  formattedFilename = formattedFilename.replace(multipleDashes, '-');
  return formattedFilename;
}
